import Unauthorized from '@/components/Unauthorized';
import { Draw } from '@/features/IDMS';
import { usePermission } from '@/hooks/usePermission';

const IDMS = () => {
  const { hasPermission } = usePermission();
  if (hasPermission(['LIST_PROJECT_DRAWS', 'READ_PROJECT_DRAW'])) {
    return <Draw />;
  }
  return <Unauthorized />;
};

export default IDMS;
